import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { TextField } from '@mui/material';
const nbFormat = new Intl.NumberFormat('no-NB', { maximumFractionDigits: 20 });
var MultipliersEnum;
(function (MultipliersEnum) {
    MultipliersEnum["m"] = "m";
    MultipliersEnum["k"] = "k";
    MultipliersEnum["b"] = "b";
    MultipliersEnum["t"] = "t";
})(MultipliersEnum || (MultipliersEnum = {}));
const multipliers = Object.keys(MultipliersEnum);
const multipliersToString = multipliers.reduce((prev, curr) => prev + curr, '');
const reg = new RegExp(`[0-9]+[${multipliersToString},.]?`, 'g');
function returnMultiplier(multiplier) {
    if (multiplier === 'm') {
        return 1e6;
    }
    else if (multiplier === 'k' || multiplier === 't') {
        return 1e3;
    }
    else if (multiplier === 'b') {
        return 1e9;
    }
    const _ensure = multiplier; // this will throw if a case is not handled
    return _ensure;
}
export const TextInputWithMillionsAndThousands = (props) => {
    const [inputValue, setInputValue] = useState(0);
    const textFieldProps = Object.assign({}, props);
    const handleChange = useCallback((e) => {
        const inputWithoutSpaces = e.target.value.replace(/\s/g, '');
        const inputWithDotsInsteadOfCommas = inputWithoutSpaces.replace(/,/g, '.');
        const match = inputWithDotsInsteadOfCommas.match(reg);
        const matchToString = !match ? '' : match.join('');
        const regexNotOverflownYet = inputWithDotsInsteadOfCommas === matchToString;
        if (regexNotOverflownYet) {
            const matchLastElement = matchToString.slice(-1);
            const matchWithoutLastElement = matchToString.substring(0, matchToString.length - 1);
            if (matchLastElement in MultipliersEnum) {
                const matchToNumber = Number(matchWithoutLastElement);
                const decimalPartOfMatch = matchToNumber % 1;
                const matchToNumberWithoutDecimal = matchToNumber - decimalPartOfMatch;
                const multiplier = returnMultiplier(matchLastElement);
                const output = matchToNumberWithoutDecimal * multiplier + decimalPartOfMatch;
                setInputValue(nbFormat.format(output));
            }
            else if (matchLastElement === '.' || matchLastElement === ',') {
                setInputValue(inputWithDotsInsteadOfCommas);
            }
            else {
                setInputValue(nbFormat.format(Number(inputWithDotsInsteadOfCommas)));
            }
        }
    }, []);
    return (_jsx(TextField, Object.assign({ value: inputValue, fullWidth: true, onChange: handleChange }, textFieldProps)));
};
